

<template>

  <v-container
    fill-height
    fluid
  >
    <v-row justify="center">

      <material-card

        :title="$t('forgotPassword.title')"
        :text="$t('forgotPassword.text')"

      >
        <v-form @submit.prevent="sendNewPassword">
          <v-container >
            <v-row>


              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="email"
                  :label="$t('user.email')"


                />
              </v-col>


              <v-col
                cols="12"
                class="text-right"
              >
                <v-btn to="/login">
                  {{$t("global.cancel")}}
                </v-btn>
                &nbsp;
                <v-btn :loading="loading"  :disabled="passwordSent" type="submit" color="success">
                  {{$t("forgotPassword.resetPassword")}}
                </v-btn>
                &nbsp;

              </v-col>

            </v-row>

            <v-alert v-if='passwordSent' >
                <v-row>
                  <v-col
                    cols="12"
                    md="6">


                {{$t('forgotPassword.passwordSent')}}
                <br />
                <v-btn to="/login">
                  {{$t("forgotPassword.toLogin")}}
                </v-btn>
                  </v-col>
              </v-row>
            </v-alert>
          </v-container>
        </v-form>
      </material-card>

    </v-row>
  </v-container>
</template>


<script>
    import api from '../components/backend/backend-api'

    export default {
        data () {
            return {
                email: '',
                loading:false,
                passwordSent:false
            }
        },
        methods: {


            sendNewPassword () {
                this.loading = true
                api.sendNewPassword(this.email).then(response => {

                    this.loading = false
                    this.passwordSent = true
                })
            }





        },
    }
</script>
